import { Responsive, TDeviceType } from '@cian/ui-kit';
import { CianLogoSign } from '@cian/ui-kit-design-tokens/logo';
import { Socials } from '../Socials';
import * as styles from './styles.css';
import type { IMappedSocialLink } from 'shared/types/socials';

interface IHeaderProps {
  socialItems: ReadonlyArray<IMappedSocialLink>;
  device: TDeviceType;
}

export const Header: React.FC<IHeaderProps> = ({ socialItems, device }) => {
  return (
    <div className={styles['container']}>
      <CianLogoSign size={device === 'phone' ? 20 : 36} />
      <Responsive desktop tablet>
        <Socials items={socialItems} />
      </Responsive>
    </div>
  );
};
